import { ReferrerTranslate } from './referrerTranslate.model';

const referrerTranslatePTBR: ReferrerTranslate = {
  kind: {
    DOULA: 'Doula',
    OBSTETRICIAN: 'Obstetra',
    NURSE: 'Enfermeira(o)',
    MATERNITY: 'Maternidade',
    OTHER: 'Outro',
  },
  combobox: {
    triggerAriaLabel: 'Selecionar parceiro de indicação',
    placeholder: 'Quem indicou',
    searchPlaceholder: 'Buscar parceiro...',
    loading: 'Carregando parceiros...',
    empty: 'Nenhum parceiro encontrado',
    clear: 'Remover parceiro',
    createNew: 'Cadastrar novo parceiro',
    createNamed: 'Cadastrar "{{name}}"',
    createTitle: 'Novo parceiro de indicação',
    editTitle: 'Editar parceiro de indicação',
    editAriaLabel: 'Editar parceiro {{name}}',
    namePlaceholder: 'Nome do parceiro',
    kindPlaceholder: 'Tipo',
    phonePlaceholder: 'Telefone (opcional)',
    instagramPlaceholder: 'Instagram (opcional)',
    cancel: 'Cancelar',
    confirm: 'Cadastrar',
    save: 'Salvar',
    delete: 'Excluir',
    confirmDelete: 'Confirmar exclusão',
  },
  settings: {
    title: 'Parceiros de indicação',
    description:
      'Doulas, obstetras e maternidades que indicam clientes. A lista é ordenada por quem mais indicou.',
    add: 'Novo parceiro',
    empty: 'Nenhum parceiro cadastrado ainda',
    leadCount: '{{count}} indicação(ões)',
    actions: {
      edit: 'Editar parceiro {{name}}',
      delete: 'Excluir parceiro {{name}}',
    },
    delete: {
      title: 'Excluir parceiro',
      text: 'Tem certeza que deseja excluir {{name}}?',
      secondaryText:
        'Os clientes indicados continuam cadastrados, mas perdem o vínculo com este parceiro.',
      confirm: 'Excluir',
      cancel: 'Cancelar',
    },
  },
  toast: {
    created: 'Parceiro cadastrado com sucesso',
    updated: 'Parceiro atualizado com sucesso',
    deleted: 'Parceiro excluído com sucesso',
    error: {
      create: 'Não foi possível cadastrar o parceiro',
      update: 'Não foi possível atualizar o parceiro',
      delete: 'Não foi possível excluir o parceiro',
    },
  },
};

export default referrerTranslatePTBR;
